import type { ElementType } from 'react'
import { useInView } from '@/hooks/use-in-view'

interface SplitTextProps {
  text: string
  as?: ElementType
  className?: string
  stagger?: number
  delay?: number
  accent?: boolean
  mode?: 'word' | 'char'
}

export function SplitText({
  text,
  as: Tag = 'span',
  className = '',
  stagger = 55,
  delay = 0,
  accent = false,
  mode = 'word',
}: SplitTextProps) {
  const [ref, inView] = useInView<HTMLElement>({ threshold: 0.2 })
  const units = mode === 'word' ? text.split(' ') : Array.from(text)
  const classes = [
    'split',
    `split--${mode}`,
    accent ? 'split--accent' : '',
    inView ? 'is-visible' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tag ref={ref} className={classes}>
      {units.map((unit, index) => (
        <span className="split__unit" key={`${unit}-${index.toString()}`}>
          <span
            className="split__inner"
            style={{ '--split-delay': `${delay + index * stagger}ms` }}
          >
            {unit === ' ' ? ' ' : unit}
          </span>
          {mode === 'word' && index < units.length - 1 ? ' ' : null}
        </span>
      ))}
    </Tag>
  )
}
